import OnAppReady from './onAppReady.js'
import OnLoginFormSubmitted from './onLoginFormSubmitted.js'
import OnLogoutRequested from './onLogoutRequested.js'
import OnSignupFormSubmitted from './onSignupFormSubmitted.js'

function initListeners(context) {
  OnAppReady.register(context)
  OnSignupFormSubmitted.register(context)
  OnLoginFormSubmitted.register(context)
  OnLogoutRequested.register(context)
}

export default initListeners
